import { QueryClient } from "react-query";
import { API_COMMENT_REPLY, API_COMMENT_SEARCH_V2_URL } from "src/api/constants/comment-v2-urls";
import { TCommentsPaginatedDataType } from "src/components/common/comments-area/utils/create-initial-replies-page-data";
import { TComment } from "../comment/comment.types";

type TUpdateCommentInfiniteQueryCache = {
    queryClient: QueryClient;
    comment: TComment;
    entityId: string;
    handleRootComment: (data: TCommentsPaginatedDataType | undefined) => TCommentsPaginatedDataType;
    handleReplyComment: (data: TCommentsPaginatedDataType | undefined) => TCommentsPaginatedDataType;
};

export const updateCommentInfiniteQueryCache = ({
    queryClient,
    comment,
    entityId,
    handleRootComment,
    handleReplyComment,
}: TUpdateCommentInfiniteQueryCache) => {
    const isARootComment = comment.rootCommentId === null;

    if (isARootComment) {
        queryClient.setQueryData<TCommentsPaginatedDataType | undefined>([API_COMMENT_SEARCH_V2_URL, entityId], handleRootComment);
    } else {
        queryClient.setQueryData<TCommentsPaginatedDataType | undefined>([API_COMMENT_REPLY, comment.rootCommentId], handleReplyComment);
    }
};
